export default function generateRandomTransform() {
  const randomTranslateX = Math.floor(Math.random() * 260) - 130; // -130%~+130%
  const randomTranslateY = Math.floor(Math.random() * 400) - 800; // -400%~-800%
  const randomRotate = Math.floor(Math.random() * 360) - 180; // -180deg~+180deg
  const randomScale = Math.random() * 0.6 + 1.4; // 1.4~2

  return `translateX(${randomTranslateX}%) translateY(${randomTranslateY}%) rotate(${randomRotate}deg) scale(${randomScale})`;
}
